import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { ThemeProvider } from '@mui/material/styles';
import theme from './theme/theme';
import './styles/global.css';
import App from './App';

// Note: MUI's <CssBaseline /> is intentionally NOT used here — the
// hand-tuned global.css (ported 1:1 from the finished mockup) already
// defines the exact base styles this design depends on, and layering
// CssBaseline on top risks subtly changing them. ThemeProvider is kept
// so any MUI primitives added later (Switch, Select, etc.) can pick up
// the matching palette/typography from theme/theme.js.
createRoot(document.getElementById('root')).render(
  <StrictMode>
    <ThemeProvider theme={theme}>
      <App />
    </ThemeProvider>
  </StrictMode>
);
